import { CheckCircleFilled, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { faCalendar, faRocket, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { Card, Timeline, Typography } from 'antd';
import React from 'react';
import SkeletonData from '../Common/SkeletonData';
import TimelineItemRow from '../Common/TimelineItemRow';
import {useQuery} from "react-admin";
const { Title } = Typography;

const getColorForState = (state: string) => {
    if (state == 'COMPLETED') {
        return 'green'
    }
    else if (state == 'ERROR') {
        return 'red'
    }
    return 'blue'
}

const getIconForState = (state: string) => {
    if (state == 'COMPLETED') {
        return <CheckCircleFilled title='Completed' style={{ color: 'green' }} />
    }
    else if (state == 'ERROR') {
        return <CloseCircleOutlined title='Error' style={{ color: 'red' }} />
    }
    return <ClockCircleOutlined title='Pending' style={{ color: 'gray' }} />
}


const ChangeInstanceLogWidget = ({ pov, filterValues }: { pov: 'CONSUMER' | 'SERVICE_OWNER', filterValues: any }) => {

    const { loading, data } = useQuery({
        type: 'getList',
        resource: pov==='CONSUMER'?"change_instances":"owner_change_instances",
        payload: {
            pagination: { page: 1, perPage: 5 },
            sort: { field: 'created', order: 'asc' },
            filter: {
                'service_id': filterValues?.service_id,
                'consumer_team_id': filterValues?.consumer_team_id,
                'application_id': filterValues?.application_id,
                light: true
            }
        }
    });

    return (
        <Card>
            <Title style={{marginBottom: '16px'}} level={5}>Change History</Title>
            <SkeletonData loading={loading}>
                <Timeline
                    pending={false}
                    className="timelinelist"
                >
                    {data && Object.keys (data).length === 0 && <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><p style={{ color: '#8c8c8c' }}>No Change History available</p></div>}
                    {data && data.map ((ci: any, index: any) => (
                        <Timeline.Item  style={{paddingBottom: "4px"}} dot={getIconForState (ci.state)} color={getColorForState (ci?.state)} key={index}>
                            <div style={{ display: 'grid', placeItems: 'stretch' }}>
                                <a
                                    href={`#/${pov==="CONSUMER"?"service_items":"owner_service_items"}/${ci?.service_item?.id}`}
                                    style={{
                                        display: 'inline',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {ci.application?.name} - {ci.service_item?.name}
                                </a>
                            </div>
                            <TimelineItemRow icon={faRocket} text={ci.service?.name}/>
                            {
                                pov == 'SERVICE_OWNER' &&
                                <TimelineItemRow icon={faUserFriends} text={ci.consumer_team?.name}/>
                            }
                            <TimelineItemRow icon={faCalendar} text={new Date (ci.modified).toLocaleDateString ('en-GB') + " " + new Date (ci.modified).toLocaleTimeString ('en-GB', {timeZone: "Europe/London"})}/>
                        </Timeline.Item>
                    ))}
                </Timeline>
            </SkeletonData>
        </Card>
    )
}

export default ChangeInstanceLogWidget
